import type { PlanSnapshot } from '@tailorcast/shared-types';

interface PlanViewProps {
  plan: PlanSnapshot;
  planVersion: number;
}

export function PlanView({ plan, planVersion }: PlanViewProps) {
  return (
    <div className="space-y-3">
      {planVersion > 1 && <div className="text-xs text-gray-500">Plan version {planVersion}</div>}

      <p className="text-sm text-gray-700">{plan.summary}</p>

      <div className="grid grid-cols-3 gap-3">
        <div className="text-center p-3 bg-gray-50 rounded-lg">
          <div className="text-lg font-bold text-gray-900">
            {plan.expectedImpact.productsAffected}
          </div>
          <div className="text-xs text-gray-500">Products</div>
        </div>
        <div className="text-center p-3 bg-gray-50 rounded-lg">
          <div className="text-lg font-bold text-tailorcast-primary">
            {plan.expectedImpact.scoreImprovement.from.toFixed(1)} →{' '}
            {plan.expectedImpact.scoreImprovement.to.toFixed(1)}
          </div>
          <div className="text-xs text-gray-500">Score Change</div>
        </div>
        <div className="text-center p-3 bg-gray-50 rounded-lg">
          <div className="text-lg font-bold text-gray-900">
            ~{Math.ceil(plan.expectedImpact.estimatedDurationSeconds / 60)}min
          </div>
          <div className="text-xs text-gray-500">Estimated Time</div>
        </div>
      </div>

      <div className="flex items-center gap-2 text-sm">
        <span className="text-gray-500">Risk:</span>
        <span
          className={`font-medium capitalize ${
            plan.riskLevel === 'low'
              ? 'text-green-600'
              : plan.riskLevel === 'medium'
                ? 'text-yellow-600'
                : 'text-red-600'
          }`}
        >
          {plan.riskLevel}
        </span>
      </div>
    </div>
  );
}
